<template lang="pug">
  button.print-button(
    @click="onClick"
  )
    include ./images/print.svg
    span Версия для печати
</template>

<script lang="ts">
  export default defineNuxtComponent({
    name: 'PrintButton',

    emits: ['click'],

    methods: {
      onClick(): void {
        this.$sendYandexMetrika({
          level1: 'Клик_распечатать_рецепт',
        });

        this.$emit('click');
        window.print();
      },
    },
  });
</script>

<style lang="scss">
  $textColor: #5c5c5c;
  $hoverColor: black;

  .print-button {
    display: flex;
    align-items: center;
    background: none;
    border: none;
    cursor: pointer;

    @include hover {
      span {
        color: $hoverColor;
      }

      svg {
        path {
          stroke: $hoverColor;
        }
      }
    }

    svg {
      margin-right: 2px;
    }

    span {
      @include fontSmallTextBtn;
      color: $textColor;
    }
  }
</style>
